'use strict';

const Item = require('../Item');

/**
 * @class
 * @hideconstructor
 * @extends HomeyAPIV3.Item
 * @memberof HomeyAPIV3.ManagerZones
 */
class Zone extends Item {

  /**
   * Get the parent zone.
   * @returns {Promise<HomeyAPIV3.ManagerZones.Zone|null>}
   */
  async getParent() {
    if (!this.parent) return null;

    return this.homey.zones.getZone({
      id: this.parent,
    });
  }

}

module.exports = Zone;
